import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { trackRoomModuleClick } from '../../utils/tracking/searchBrowse/nullResultsTracking';

// components
import { SbRespNullSearchResultsHeader } from './SbRespNullSearchResultsHeader';
import { SbRespNullSearchResultsTilesLoader } from './SbRespNullSearchResultsTilesLoader';
import { CategoryRooms } from 'dibs-buyer-layout/exports/CategoryLinks';
import { SbRespFollowSearchBanner } from '../SbRespFollowSearchBanner/SbRespFollowSearchBanner';
import { SbSharedFollowSearchProvider } from '../SbSharedFollowSearchProvider/SbSharedFollowSearchProvider';

const onRoomModuleClick = (e, { room }) => trackRoomModuleClick(room.type);

export const SbRespNullSearchResultsComponent = props => {
    const { user, page, relay, viewer, searchTerm, searchBrowse, uriRef } = props;
    const { isShopByRoomEnabled, isSbRespFollowSearchBannerEnabled } = viewer;
    const { environment } = relay;

    return (
        <SbSharedFollowSearchProvider
            user={user}
            page={page}
            uriRef={uriRef}
            searchTerm={searchTerm}
            searchBrowse={searchBrowse}
            thinTrackingEnabled={false}
        >
            {({ showFollowButton, isFollowing, followSearchValue, onFollowSearchCompleted }) => (
                <React.Fragment>
                    <SbRespNullSearchResultsHeader
                        searchBrowse={searchBrowse}
                        searchTerm={searchTerm}
                    />
                    {isSbRespFollowSearchBannerEnabled && (
                        <SbRespFollowSearchBanner
                            user={user}
                            viewer={viewer}
                            buttonSize="large"
                            uriRef={uriRef}
                            isFollowing={isFollowing}
                            showFollowButton={showFollowButton}
                            followSearchValue={followSearchValue}
                            onFollowSearchCompleted={onFollowSearchCompleted}
                        />
                    )}
                    <SbRespNullSearchResultsTilesLoader environment={environment} />
                    {isShopByRoomEnabled && <CategoryRooms onClick={onRoomModuleClick} />}
                </React.Fragment>
            )}
        </SbSharedFollowSearchProvider>
    );
};

SbRespNullSearchResultsComponent.propTypes = {
    user: PropTypes.object,
    uriRef: PropTypes.string,
    viewer: PropTypes.object,
    searchTerm: PropTypes.string,
    page: PropTypes.number.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
};

export const SbRespNullSearchResults = createFragmentContainer(SbRespNullSearchResultsComponent, {
    user: graphql`
        fragment SbRespNullSearchResults_user on User {
            ...SbRespFollowSearchBanner_user
            ...SbSharedFollowSearchProvider_user
        }
    `,
    viewer: graphql`
        fragment SbRespNullSearchResults_viewer on Viewer {
            isShopByRoomEnabled: isEnabledByLocale(featureName: "SHOP_BY_ROOM")
            isSbRespFollowSearchBannerEnabled: isEnabledByLocale(
                featureName: "NON_MVP_SEARCH_BROWSE"
            )
            ...SbRespFollowSearchBanner_viewer
        }
    `,
    searchBrowse: graphql`
        fragment SbRespNullSearchResults_searchBrowse on SearchBrowseQueryConnection {
            ...SbSharedFollowSearchProvider_searchBrowse
            ...SbRespNullSearchResultsHeader_searchBrowse
        }
    `,
});
